module.exports = __webpack_public_path__ + "img/corner-mezzanine.fb37e9f6.jpg";